// Shared root for Address and Region
//
// TODO: Separate out properties that are PLACE only.
const Coordinate = require('./coordinate');

class Place {
  /*:: static jsonToInitObj: (Object) => PlaceInitObject; */

  /*:: static fromJson: (Object) => Place; */
  constructor(args
  /*: PlaceInitObject*/
  = {}) {
    this.id = args.id;
    this.token = args.token;
    this.osmUid = args.osmUid || args.osmId;
    this.osmEditUrl = args.osmEditUrl;
    this.suite = args.suite;
    this.building = args.building;
    this.streetAddress = args.streetAddress;
    this.street = args.street;
    this.neighbourhood = args.neighbourhood;
    this.city = args.city;
    this.state = args.state;
    this.county = args.county;
    this.country = args.country;
    this.postalcode = args.postalcode;
    this.locality = args.locality;
    this.timezone = args.timezone;
    this.centre = args.centre ? new Coordinate(args.centre) : null;
    this.area = args.area;
    this.raw = args.raw;
    this.isComplete = args.isComplete;
  }

}

Place.jsonToInitObj = json => Object.assign({
  raw: json.raw,
  token: json.token,
  isComplete: json.isComplete,
  osmEditUrl: json.osmEdit
}, json.data);

Place.fromJson = json => new Place(Place.jsonToInitObj(json));

module.exports = Place;